import styled from "styled-components";
import Fundo from '../img/Fundo_Promocao.png';

export const DivPromocoes = styled.div`
    position: relative;
    margin: 2vh auto 0;
    width: 85.9%;
    aspect-ratio: 1920 / 540;
    overflow: hidden;
    border-radius: 6px;
    border: 2px solid #d5d5d5;
    box-sizing: border-box;
    font-family: Verdana, Geneva, Tahoma, sans-serif;
    background-image: url(${Fundo});
    background-size: cover;
    background-position: top center;
    background-repeat: no-repeat;

    .conteudo {
        position: absolute;
        inset: 0;
        display: flex;
        align-items: center;
        padding: 2% 5%;
        box-sizing: border-box;
    }

    .coluna-esquerda {
        width: 52%;
    }

    h1 {
        margin: 0;
        font-size: 3.4vw;
        font-weight: 900;
        color: #F0524F;
        text-shadow: 3px 3px 0px rgba(240, 82, 79, 0.25);
        letter-spacing: 0.05vw;
    }

    p {
        margin: 1% 0 2.5%;
        font-size: 1.1vw;
        line-height: 1.4;
        color: #262626;
        font-weight: 500;
    }

    .botao {
        display: inline-block;
        background-color: #F0524F;
        color: #fff;
        font-weight: 700;
        font-size: 1.1vw;
        text-decoration: none;
        padding: 0.7vw 1.8vw;
        border-radius: 2vw;
        transition: background-color 0.2s ease;

        :hover {
            background-color: #d63d3a;
        }
    }

    .coluna-direita {
        position: absolute;
        inset: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        transform: translateX(10%);
        pointer-events: none;

        img {
            width: 19.2vw;
            max-height: 90%;
            object-fit: contain;
        }
    }

    .linha-final {
        position: absolute;
        left: 5%;
        bottom: 6%;
        width: 42%;
        height: 0.3vw;
        background-color: #F5A623;

        .quadrado {
            position: absolute;
            top: 50%;
            right: -1vw;
            transform: translateY(-50%);
            width: 1vw;
            height: 1vw;
            background-color: #F5A623;
        }
    }

    @media screen and (max-width: 750px) {
        aspect-ratio: auto;
        width: 100%;
        margin: 0px;
        border-radius: 0px;

        .conteudo {
            position: static;
            flex-direction: column;
            padding: 6vw 5vw 10vw;
        }

        .coluna-esquerda {
            width: 100%;
            text-align: center;
        }

        h1 {
            font-size: 8vw;
        }

        p {
            font-size: 3.8vw;
            margin: 3vw 0;
        }

        .botao {
            font-size: 3.8vw;
            padding: 2.5vw 6vw;
            border-radius: 6vw;
        }

        .coluna-direita {
            position: static;
            width: 100%;
            margin-top: 5vw;
            transform: none;

            img {
                width: 44vw;
            }
        }

        .linha-final {
            display: none;
        }
    }
`;
